/*
 * Copyright (c) 2020. American Express Company
 */

import * as _ from 'lodash';
import BWDataService from './bw-data.service';

export class LifeInsuranceEstimate {
    age: number = 40;
    gender: 'M' | 'F' | 'O' = 'M';
    health: 'PREFERRED_PLUS' | 'PREFERRED' | 'STANDARD' | 'SUBSTANDARD' = 'STANDARD';
    termLength: number = 20; // from 5 to 30, multiple of 5
    coverageAmount: number = 750000;

    /** Check that this object is valid. Could use Joi and copy from route in Node, but feels silly to add that whole
     * library for this.
     */
    public static isValid(e: LifeInsuranceEstimate): boolean {
        return (
            isFinite(Number(e.age)) &&
            _.isString(e.gender) &&
            _.isString(e.health) &&
            isFinite(Number(e.termLength)) &&
            isFinite(Number(e.coverageAmount))
        );
    }
}

/**
 * TODO the backend returns a "notAvailable" boolean, and it looks like that -- and monthlyPremium, are
 * not used here -- maybe we should just remove them
 */
interface InsuranceResponse {
    monthlyPremium: number;
    annualPremium: number;
}

export default class InsuranceService extends BWDataService {
    public static async getLifeInsuranceEstimate(estimate: LifeInsuranceEstimate): Promise<number> {
        const response: InsuranceResponse = await this.post('/insurance/estimate', estimate);
        return _.get(response, 'annualPremium');
    }
}
